import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../../../app/store/configureStore';
import { createMenuAsync, updateMenuAsync } from '../store/menuSlice';
import { MenuFormData } from '../types';

export const useMenuForm = (restaurantId: string) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();

  const handleFormSubmit = useCallback(
    async (data: MenuFormData, menuId?: string) => {
      setIsSubmitting(true);
      try {
        if (menuId) {
          await dispatch(
            updateMenuAsync({
              restaurantId,
              menuId,
              data,
            })
          ).unwrap();
        } else {
          await dispatch(
            createMenuAsync({
              restaurantId,
              data,
            })
          ).unwrap();
        }
      } finally {
        setIsSubmitting(false);
      }
    },
    [dispatch, restaurantId]
  );

  return {
    handleFormSubmit,
    isSubmitting,
  };
};
